import React from 'react';

/**
 * Empty state for the Management Task card grids. Spans every column so the
 * grid does not collapse to a single narrow cell, matching the dashed panel
 * the project grid uses in ProjectsList.jsx — text only, since the shared
 * NoData illustration carries its own message baked in. `hint` and `action`
 * let a grid carry its create call to action here, so an empty grid shows one
 * invite to create instead of an add tile beside an empty panel.
 */
const CardGridEmpty = ({ message, hint, action }) => (
    <div className="rounded-2xl border border-dashed border-[#C7D3DE] bg-white flex flex-col items-center justify-center text-center p-10 gap-3 sm:col-span-2 xl:col-span-3">
        <div>
            <p className="text-base font-semibold text-stone-600">{message}</p>
            {hint && <p className="text-sm text-stone-500 mt-1">{hint}</p>}
        </div>
        {action}
    </div>
);

export default CardGridEmpty;
